import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserRound } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { ImageUpload } from "@/components/ImageUpload";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const HostProfileCard = ({ member, onSaved }) => {
  const [bio, setBio] = useState(member?.bio || "");
  const [image, setImage] = useState(member?.image_url || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setBio(member?.bio || ""); setImage(member?.image_url || ""); }, [member]);

  if (!member) return null;
  const dirty = bio !== (member.bio || "") || image !== (member.image_url || "");

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/portal/profile", { bio, image_url: image }); toast.success("Profile updated"); onSaved(data); }
    catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="card-surface rounded-3xl p-5" data-testid="host-profile-card">
      <p className="eyebrow mb-3 flex items-center gap-1.5"><UserRound size={12} /> Your profile</p>
      <div className="flex flex-col items-center">
        <ImageUpload value={image} onChange={(v) => setImage(v || "")} endpoint="/portal/upload-photo" testId="host-profile-photo" allowUrl={false} hint={false} />
        <p className="mt-3 font-display font-bold" data-testid="host-profile-name">{member.name}</p>
        <p className="text-xs text-slate-400">{member.role}</p>
      </div>
      <div className="mt-4">
        <Label>Bio</Label>
        <Textarea value={bio} onChange={(e) => setBio(e.target.value)} rows={5} maxLength={2000} placeholder="Tell listeners who you are — shown on your host page." className="mt-1.5 bg-white/5 border-white/10 text-sm" data-testid="host-profile-bio" />
        <p className="mt-1 text-right text-[11px] text-slate-500">{bio.length}/2000</p>
      </div>
      <Button type="button" onClick={save} disabled={!dirty || busy} className="mt-2 w-full rounded-full bg-sky-400 text-[#070F1E] font-bold hover:bg-sky-300" data-testid="host-profile-save">{busy ? "Saving…" : "Save profile"}</Button>
    </div>
  );
};
